import BaseModel from './BaseModel';
import Membership from './Membership';
import moment from 'moment';

/** Class representing an user. */
class Member extends BaseModel {
    constructor(properties) {
        super(properties);

        this.created_at = moment(this.created_at);
        this.updated_at = moment(this.updated_at);

        if ('membership' in this)
            this.membership = new Membership(this.membership);
    }
}

export default Member;
